import type { FrameName } from "@/game/entities/config";
import type { ResourceType } from "@/game/entities/config/resources";

export enum MilestoneRewardType {
	CURRENCY = "currency",
	ITEM = "item",
}

export type MilestoneInGameRewardCurrency = {
	type: MilestoneRewardType.CURRENCY;
	amount: number | (() => number);
	currency: ResourceType;
};

export type MilestoneInGameRewardBuilding = {
	type: MilestoneRewardType.ITEM;
	amount: number;
	frameName: FrameName;
};

export enum MilestoneStatus {
	CLAIMED = "claimed",
	CLAIMABLE = "claimable",
	LOCKED = "locked",
}

export type MilestoneItem = {
	requiredSum: number;
	reward: MilestoneInGameRewardCurrency | MilestoneInGameRewardBuilding;
	status?: MilestoneStatus;
	premium?: {
		reward: MilestoneInGameRewardCurrency | MilestoneInGameRewardBuilding;
		status?: MilestoneStatus;
	};
};

export enum MarketChestType {
	COMMON = "common",
	RARE = "rare",
	LEGENDARY = "legendary",
}

export enum MarketDropRateType {
	COMMON = "common",
	UNCOMMON = "uncommon",
	RARE = "rare",
}
